// removed by extract-text-webpack-plugin
module.exports = {"micrositeContainer":"micrositeContainer--1axhp","headerContainer":"headerContainer--m-6SG","feedbackSection":"feedbackSection--2qhQe"};